module.exports = __webpack_public_path__ + "8e4fbf8a6d9b08630516345517c6b025.svg";